import * as React from 'react';

import IntersectionContext from './context';

function useIntersection() {
  const context = React.useContext(IntersectionContext);

  if (!context) {
    throw new Error('useIntersection must be used inside a IntersectionProvider');
  }

  return context;
}

export default useIntersection;